import { Box, Button, Card, Grid, List, ListItem, ListItemAvatar, ListItemText, Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import DonutChart from 'src/components/chart/DonutChart';
import Layout from 'src/components/layout/Layout';
import StorageDonutChart from './components/StorageDonutChart';
import TvIcon from '@mui/icons-material/Tv';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import EventIcon from '@mui/icons-material/Event';

const UserCaps = ({ user }) => {
  const { t } = useTranslation();

  const { caps } = useSelector((state) => state.UsersCaps);

  console.log(user)

  console.log(caps);

  function formatBytes(bytes, decimals = 2) {
    if (!+bytes) return '0 Bytes';

    const dm = decimals < 0 ? 0 : decimals;

    return `${parseFloat((bytes / 1073741824).toFixed(4))} GB`;
  }

  function convertGBtoBytes(gb) {
    return gb * 1073741824;
  }

  return user?.userCaps?.fileCount ? (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
      }}
      p={3}
    >
      <Grid container spacing={2}>
        <Grid xs={12} lg={3} md={4}>
          <Card
            variant='outlined'
            sx={{
              p: 2,
              m: 3,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
            }}
          >
            <Typography variant='h5'>
              {t('view.userCaps.storageUsed')}
            </Typography>
            <StorageDonutChart
              usage={Math.ceil(
                (user?.userCaps?.totalStorageUsage[0].totalStorageUsage / convertGBtoBytes(Number(user?.plan?.planFeatures?.find(pf => pf.slug == 'storage').value)))*100
              )}
            />
            <Typography variant='subtitle1'>{formatBytes(user?.userCaps?.totalStorageUsage[0].totalStorageUsage)} / {user?.plan?.planFeatures?.find(pf => pf.slug == 'storage').value} GB</Typography>
          </Card>
        </Grid>   
        <Grid xs={12} lg={3} md={4}>
          <Card
            variant='outlined'
            sx={{
              p: 2,
              m: 3,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
            }}
          >
            <Typography variant='h5'>
              {t('view.userCaps.screensUsage')}
            </Typography>
            <StorageDonutChart
              usage={Math.ceil(
                (user?.userCaps?.screensCount / Number(user?.plan?.planFeatures?.find(pf => pf.slug == 'max_screens').value))*100
              )}
            />
            <Typography variant='subtitle1'>{user?.userCaps?.screensCount} of {user?.plan?.planFeatures?.find(pf => pf.slug == 'max_screens').value} {Number(user?.plan?.planFeatures?.find(pf => pf.slug == 'max_screens').value) > 1 ? t("view.userCaps.screenOther") : t("view.userCaps.screenOne")}</Typography>
          </Card>
        </Grid>  
        <Grid xs={12} lg={3} md={4}>
          <Card
            variant='outlined'
            sx={{
              p: 2,
              m: 3,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
            }}
          >
            <Typography variant='h5'>
              {t('view.userCaps.schedulersUsage')}
            </Typography>
            <StorageDonutChart
              usage={Math.ceil(
                (user?.userCaps?.schedulersCount / Number(user?.plan?.planFeatures?.find(pf => pf.slug == 'max_schedulers').value))*100
              )}
            />
            <Typography variant='subtitle1'>{user?.userCaps?.schedulersCount} of {user?.plan?.planFeatures?.find(pf => pf.slug == 'max_schedulers').value} {Number(user?.plan?.planFeatures?.find(pf => pf.slug == 'max_schedulers').value) > 1 ? t("view.userCaps.schedulerOther") : t("view.userCaps.schedulerOne")}</Typography>
          </Card>
        </Grid>                    
        {/* <Grid xs={12} lg={3} md={4} mr={3}>
          <Card
            variant='outlined'
            sx={{
              p: 2,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
            }}
          >
            <List>
              <ListItem>
                <ListItemAvatar>
                  <TvIcon />
                </ListItemAvatar>
                <ListItemText primary={caps?.screensCount} secondary={t('view.userCaps.screensUsage')+`(${user?.plan?.planFeatures?.find(pf => pf.slug == 'max_screens').value} ${t("view.userCaps.available")})`} />
              </ListItem>
              <ListItem>
                <ListItemAvatar>
                  <CalendarMonthIcon />
                </ListItemAvatar>
                <ListItemText primary={caps?.schedulersCount} secondary={t('view.userCaps.schedulersUsage')+`(${user?.plan?.planFeatures?.find(pf => pf.slug == 'max_schedulers').value} ${t("view.userCaps.available")})`} />
              </ListItem>
              <ListItem>
                <ListItemAvatar>
                  <EventIcon />
                </ListItemAvatar>
                <ListItemText primary={caps?.eventsCount} secondary={t('view.userCaps.eventsUsage')} />
              </ListItem>               
            </List>
          </Card>
        </Grid>            */}
      </Grid>
    </Box>
  ) : (
    <Typography variant='h5' textAlign='center' mt={3}>
      {t('view.userCaps.noAccountResources')}
    </Typography>
  );
};

export default UserCaps;
